import React from 'react';
import loadable from '@loadable/component';

const Dialog = loadable(() =>
  import(/* webpackChunkName: "extra" */ './dialog')
);

const LoadableDialog = props => <Dialog {...props} />;

export default LoadableDialog;
